import Routing from "routing";
import "react-rangeslider/lib/index.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-device-frameset/styles/marvel-devices.min.css";
import "./App.scss";
import ScrollToTop from "routing/ScrollTop";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { AxiosInterceptor } from "config/axiosInstance";
import appStore from "./store/appStore";
import { Provider } from "react-redux";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.language]);

  return (
    <div className="App">
      <BrowserRouter basename="/">
        {/* <HashRouter> */}
        <Provider store={appStore}>
          <AxiosInterceptor>
            <ScrollToTop />
            <Routing />
          </AxiosInterceptor>
        </Provider>
        {/* </HashRouter> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
